var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardCardLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 25,
    viewBox: "0 0 48 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9876 0C10.8113 0 0 10.8113 0 23.9876H3.37854C3.37854 12.6692 12.6698 3.37854 23.9876 3.37854C35.3054 3.37854 44.5967 12.6698 44.5967 23.9876H47.9752C48.1441 10.8113 37.3325 0 23.9876 0Z",
    fill: "#FF4800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0138 22.4676L30.7437 11.9941L20.2703 16.7241C18.9189 17.3998 18.0742 18.9201 18.0742 20.4405C18.0742 22.8055 19.9324 24.6636 22.2974 24.6636C23.9867 24.6636 25.3381 23.819 26.0138 22.4676Z",
    fill: "#FF4800"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardLogo);
export default __webpack_public_path__ + "static/media/dashboard-card-logo.de4fc9dd8d09d09cc5fb37c06f32e3ca.svg";
export { ForwardRef as ReactComponent };